module.exports = __webpack_public_path__ + "static/img/yykj.fa11367.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/yykj.png
// module id = zkVV
// module chunks = 1